import React from "react";
import { useSelector } from "react-redux";
import CityPart from "./CityPart";
import { DragescentState } from "../../store/reducers/stateType";

interface IProps {
  active: string[];
}

const CityParts = ({ active }: IProps) => {
  const slotChains = useSelector((state: DragescentState) => state.governorate.slotChains);

  return (<>
    {Object.keys(slotChains).map(
      key => <CityPart
        key={key}
        slotChain={slotChains[key]}
        active={active.includes(key)}
      />
    )}
  </>)
}

export default CityParts;
